export const stepConfig = [
  {target: '.Options', key: 'homeWelcome'},
  {target: '.microLessonsCard', key: 'microLessonsCard'},
  {target: '.videosCard', key: 'videosCard'},
  {target: '.coursesCard', key: 'coursesCard'},
  {target: '.aiAssistantsCard', key: 'aiAssistantsCard'},
];
